import { useVerandaSelector } from '../../../..'
import { Helper } from '../../../../classes/helper'
import { useSidewall } from '../../../../hooks/state/useSidewall'
import { Keys } from '../../../../hooks/state/utlility/utils'
import { CachedMeshPhysicalMaterial } from '../../../material/cachedMeshPhysicalMaterial'
import { SideTie } from '../window/side/tie/SideTie'
import { SlidingDoorHandleWithLock } from './slidingDoor/SlidingDoorHandleWithLock'
import { Window } from './slidingDoor/Window'

interface Props {
  hasFrame: boolean
}

export const FrameSlidingDoor = (): JSX.Element => {
  const {
    plankHeight,
    sidwallTyp,
    windowsSideWidth,
    slidingDoorPosition,
    spaceBetween,
    sideWall,
    type,
    spaceBetweenY,
    slidingPositionLeft,
    frameDoorTyp,
  } = useSidewall()

  const shadingMode = useVerandaSelector((state) => state.scene.shadingMode)

  const NUM_ELEMENTS = frameDoorTyp.typ1 ? 0 : 2
  const NUM_DOORS = 2

  const elementDepth = sidwallTyp.glas + sidwallTyp.log.depth
  const singleElementWidth = spaceBetween / (NUM_DOORS + NUM_ELEMENTS)

  const checkBottomLogSize =
    sidwallTyp.log.depth > (sidwallTyp.glas + 0.005) * NUM_DOORS
      ? sidwallTyp.log.depth * 2
      : (sidwallTyp.glas + 0.005) * NUM_DOORS

  const renderHandle = (index: number): boolean => {
    if (NUM_ELEMENTS > 0) return true
    return (
      (index === 1 && slidingPositionLeft) ||
      (index === 0 && !slidingPositionLeft)
    )
  }

  return (
    <group
      key={'SlidingFrameDoorContainer'}
      position={[
        type === Keys.Seitenwände.Values.SeitenwandRechts.key
          ? -sidwallTyp.log.depth / 2
          : sidwallTyp.log.depth / 2,
        sideWall.hasPlankWall ? plankHeight : 0,
        0,
      ]}
    >
      {[...Array(NUM_ELEMENTS)].map((_, index) => (
        <Window
          key={`WindowframeSlidingWall${index}`}
          height={spaceBetweenY}
          position={[
            type === Keys.Seitenwände.Values.SeitenwandRechts.key
              ? sidwallTyp.log.depth / 2
              : -sidwallTyp.log.depth / 2,
            sidwallTyp.log.width,
            -(spaceBetween - singleElementWidth) / 2 -
              (spaceBetween - singleElementWidth) * (index - 1),
          ]}
          frame={true}
          windowWitdth={singleElementWidth}
          total={NUM_ELEMENTS}
        />
      ))}

      {[...Array(NUM_DOORS)].map((_, index) => {
        const doorPosition: [number, number, number] = [
          NUM_ELEMENTS > 0
            ? type === Keys.Seitenwände.Values.SeitenwandRechts.key
              ? slidingDoorPosition
                ? elementDepth / 2
                : -elementDepth / 2
              : slidingDoorPosition
              ? -elementDepth / 2
              : elementDepth / 2
            : index
            ? shadingMode && !slidingPositionLeft && slidingDoorPosition
              ? 0
              : type === Keys.Seitenwände.Values.SeitenwandRechts.key
              ? slidingDoorPosition
                ? elementDepth / 2
                : -elementDepth / 2
              : slidingDoorPosition
              ? -elementDepth / 2
              : elementDepth / 2
            : shadingMode && !slidingPositionLeft
            ? slidingDoorPosition
              ? -elementDepth / 2
              : elementDepth / 2
            : 0,
          sidwallTyp.log.width,
          NUM_ELEMENTS
            ? ((spaceBetween -
                singleElementWidth -
                (index
                  ? type === 'seitenwandLinks'
                    ? -0.025
                    : sidwallTyp.log.width
                  : 0.05)) /
                2 -
                index * singleElementWidth -
                singleElementWidth) *
              (shadingMode ? 1 : 2)
            : (-spaceBetween / 2) * index +
              singleElementWidth / 2 -
              (shadingMode
                ? 0
                : slidingPositionLeft
                ? index
                  ? -singleElementWidth / 1.5
                  : 0
                : index
                ? -singleElementWidth / 3
                : singleElementWidth),
        ]

        return (
          <group
            key={`WindowFrameSlidingDoorGroup${index}`}
            position={[
              type === Keys.Seitenwände.Values.SeitenwandRechts.key
                ? sidwallTyp.log.depth / 2
                : -sidwallTyp.log.depth / 2,
              0,
              type === Keys.Seitenwände.Values.SeitenwandHinten.key ? -0.02 : 0,
            ]}
          >
            <Window
              key={`WindowFrameSlidingDoor${index}`}
              height={spaceBetweenY}
              position={doorPosition}
              frame={true}
              windowWitdth={singleElementWidth}
              total={NUM_DOORS}
            />

            {renderHandle(index) && (
              <SlidingDoorHandleWithLock
                position={[
                  type === Keys.Seitenwände.Values.SeitenwandRechts.key
                    ? slidingDoorPosition
                      ? 0
                      : -sidwallTyp.log.depth
                    : slidingDoorPosition
                    ? -sidwallTyp.log.depth / 2
                    : sidwallTyp.log.depth,
                  doorPosition[1] + 0.7,
                  NUM_ELEMENTS
                    ? doorPosition[2] +
                      (index
                        ? singleElementWidth / 2
                        : -singleElementWidth / 2) +
                      (index
                        ? -sidwallTyp.log.width / 2 + 0.007
                        : sidwallTyp.log.width / 2 - 0.007)
                    : slidingPositionLeft
                    ? doorPosition[2] - singleElementWidth / 2
                    : shadingMode
                    ? doorPosition[2] + singleElementWidth / 2
                    : singleElementWidth / 3,
                ]}
                rotation={[
                  Helper.convertAngleToRadiant(0),
                  type === Keys.Seitenwände.Values.SeitenwandRechts.key
                    ? Helper.convertAngleToRadiant(
                        slidingDoorPosition ? 90 : -90
                      )
                    : Helper.convertAngleToRadiant(
                        slidingDoorPosition ? -90 : 90
                      ),
                  Helper.convertAngleToRadiant(0),
                ]}
              />
            )}

            <mesh
              castShadow={true}
              position={[
                type === Keys.Seitenwände.Values.SeitenwandLinks.key
                  ? slidingDoorPosition
                    ? 0
                    : elementDepth / 2 + sidwallTyp.log.depth / 2
                  : 0,
                sidwallTyp.log.width,
                0,
              ]}
              rotation={[
                Helper.convertAngleToRadiant(0),
                Helper.convertAngleToRadiant(90),
                Helper.convertAngleToRadiant(0),
              ]}
            >
              <boxGeometry
                args={[
                  spaceBetween - sidwallTyp.glas / 2,
                  0.00835,
                  sidwallTyp.log.depth / 2,
                ]}
              />
              <CachedMeshPhysicalMaterial color={'silver'} metalness={0.9} />
            </mesh>
          </group>
        )
      })}

      {[...Array(2)].map((_, index) => (
        <SideTie
          size={[checkBottomLogSize, sidwallTyp.log.width, spaceBetween]}
          rotation={[0, 0, 0]}
          key={`SideTieHorizontal${index}`}
          position={[0, index ? spaceBetweenY : sidwallTyp.log.width / 2, 0]}
        />
      ))}

      {[...Array(2)].map((_, index) => (
        <SideTie
          size={[sidwallTyp.log.depth, spaceBetweenY, sidwallTyp.log.width]}
          rotation={[0, 0, 0]}
          key={`SideTieVertical${index}`}
          position={[
            0,
            spaceBetweenY / 2,
            index
              ? spaceBetween / 2
              : (-spaceBetween + sidwallTyp.log.width) / 2,
          ]}
        />
      ))}
    </group>
  )
}
